import React from 'react';
import { getScriptSurePatientId } from 'api/textVisit';

let globalData: string = '';

const useGetScriptSurePatientId = (prospectId?: string | number): [string, boolean, () => void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<string>(globalData);
    const fetchData = async () => {
        if (!prospectId) return;
        try {
            loading.current = true;
            const result = await getScriptSurePatientId(prospectId);
            if (!result.error) {
                const data: string = result?.data?.data;
                globalData = data;
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        fetchData();
    }, [prospectId]);

    return [items, loading.current, fetchData];
};

export default useGetScriptSurePatientId;
